import { formatDayShort, toggleDate } from '../lib/dates'

export function AvailabilityPicker({
  days,
  selected,
  onChange,
  tripStart,
  tripEnd,
  label = 'When can you go?',
}: {
  days: string[]
  selected: string[]
  onChange: (next: string[]) => void
  tripStart?: string
  tripEnd?: string
  label?: string
}) {
  if (days.length === 0) {
    return (
      <div className="avail-empty muted">Pick trip dates first to set availability.</div>
    )
  }

  return (
    <div className="avail-picker">
      <div className="avail-picker-head">
        <span className="avail-label">{label}</span>
        <span className="avail-hint faint">Tap the days that work</span>
      </div>
      <div className="avail-chips" role="group" aria-label={label}>
        {days.map((d) => {
          const on = selected.includes(d)
          const inTrip = tripStart && tripEnd && d >= tripStart && d <= tripEnd
          return (
            <button
              key={d}
              type="button"
              className={`avail-chip${on ? ' on' : ''}${inTrip ? ' core' : ''}`}
              aria-pressed={on}
              onClick={() => onChange(toggleDate(selected, d))}
            >
              <span className="avail-chip-day">{formatDayShort(d)}</span>
              {on && <span className="avail-chip-check" aria-hidden>✓</span>}
            </button>
          )
        })}
      </div>
      <div className="row" style={{ gap: 8, marginTop: 4 }}>
        <button
          type="button"
          className="btn sm ghost"
          onClick={() => onChange(tripStart && tripEnd ? days.filter((d) => d >= tripStart && d <= tripEnd) : [...days])}
        >
          Trip days only
        </button>
        <button type="button" className="btn sm ghost" onClick={() => onChange([...days])}>
          All
        </button>
        <button type="button" className="btn sm ghost" onClick={() => onChange([])}>
          Clear
        </button>
      </div>
    </div>
  )
}

export function AvailabilityMatrix({
  days,
  rows,
}: {
  days: string[]
  rows: { name: string; dates: string[]; highlight?: boolean }[]
}) {
  if (days.length === 0 || rows.length === 0) return null
  return (
    <div className="avail-matrix-wrap">
      <div className="avail-matrix" style={{ gridTemplateColumns: `minmax(88px, 1.1fr) repeat(${days.length}, minmax(36px, 1fr))` }}>
        <div className="avail-matrix-corner faint">Crew</div>
        {days.map((d) => (
          <div key={d} className="avail-matrix-day faint" title={d}>
            {formatDayShort(d).split(' ')[0]}
            <br />
            <strong>{d.slice(8)}</strong>
          </div>
        ))}
        {rows.map((row) => (
          <div key={row.name} className="avail-matrix-row-contents" style={{ display: 'contents' }}>
            <div className={`avail-matrix-name${row.highlight ? ' highlight' : ''}`}>{row.name}</div>
            {days.map((d) => {
              const on = row.dates.includes(d)
              return (
                <div
                  key={d}
                  className={`avail-matrix-cell${on ? ' on' : ''}`}
                  title={on ? `${row.name} free ${d}` : undefined}
                >
                  {on ? '●' : '·'}
                </div>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}
